import { adminHttpClient } from '../commons/adminHttpClient'

export type CreateCompanyForTestingRequest = {
  name: string
  email: string
  benefitStartDate: Date
  benefitEndDate: Date
  numberOfEligibleEmployees: number
  numberOfIneligibleEmployees: number
  productId: number
  allowanceType: number
  productClasses: ProductClassRequest[]
  isAle: boolean
  numberOfNotAttestedEmployees: number
}

export type ProductClassRequest = {
  classTypeId: number
  waitingPeriod: number
  familyAllowances: ProductClassFamilyAllowanceRequest[]
  categoryAllowances: ProductClassCategoryAllowanceRequest[]
}

export type ProductClassFamilyAllowanceRequest = {
  familyStatusId: number
  amount: number
}

export type ProductClassCategoryAllowanceRequest = {
  categoryId: number
  amount: number
}

export const createCompanyForTesting = (request: CreateCompanyForTestingRequest): Promise<string> => {
  return adminHttpClient.post(`/Companies/CreateCompanyForTesting`, request)
}
